import type { SVGProps } from 'react';
const SvgAddCard = (props: SVGProps<SVGSVGElement>) => (
	<svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
		<defs>
			<linearGradient id="linear-gradient-sunrise" x1="0" y1="28" x2="0" y2="0" gradientUnits="userSpaceOnUse">
				<stop offset="0%" stopColor="#FE9311" />
				<stop offset="100%" stopColor="#FFDB00" />
			</linearGradient>
		</defs>
		<path d="M22.1666 3.5H3.49996C2.20496 3.5 1.17829 4.53833 1.17829 5.83333L1.16663 19.8333C1.16663 21.1283 2.20496 22.1667 3.49996 22.1667H15.1666V19.8333H3.49996V12.8333H24.5V5.83333C24.5 4.53833 23.4616 3.5 22.1666 3.5ZM22.1666 8.16667H3.49996V5.83333H22.1666V8.16667ZM26.8333 18.6667V21H23.3333V24.5H21V21H17.5V18.6667H21V15.1667H23.3333V18.6667H26.8333Z" />
	</svg>
);
export default SvgAddCard;
